import { z } from "zod";
import {
  VALIDATION_MESSAGES,
  REGEX_PATTERNS,
  VALIDATION_LIMITS,
} from "../constants";
import { requiredString } from "../utils/validationUtils";

// Define validation schema for driver data
export const driverDataSchema = z.object({
  ulid: z.string().optional(),
  name: requiredString(VALIDATION_MESSAGES.REQUIRED.NAME).describe(
    "Nama pengemudi"
  ),
  username: requiredString("Username tidak boleh kosong")
    .min(6, "Username minimal 6 karakter")
    .max(15, "Username maximal 15 karakter")
    .regex(
      REGEX_PATTERNS.USERNAME_PATTERN,
      VALIDATION_MESSAGES.FORMAT.USERNAME_PATTERN
    )
    .optional()
    .describe("Username driver"),
  phone: requiredString("Nomor handphone tidak boleh kosong")
    .regex(REGEX_PATTERNS.PHONE_NUMBER, VALIDATION_MESSAGES.FORMAT.PHONE_NUMBER)
    .min(9, "Nomor handphone minimal 9 karakter tanpa kode negara")
    .max(12, "Nomor handphone maksimal 12 karakter tanpa kode negara")
    .optional()
    .describe("Nomor handphone driver"),
  status: z.enum(["active", "inactive"]).describe("Status"),
  ktp_number: requiredString("Nomor KTP tidak boleh kosong")
    .regex(
      REGEX_PATTERNS.NUMERIC_ONLY,
      VALIDATION_MESSAGES.FORMAT.KTP_NUMBER_NUMERIC
    )
    .length(16, "Nomor KTP harus 16 karakter")
    .optional()
    .describe("Nomor KTP driver"),
  sim_number: requiredString("Nomor SIM tidak boleh kosong")
    .regex(
      REGEX_PATTERNS.NUMERIC_ONLY,
      VALIDATION_MESSAGES.FORMAT.SIM_NUMBER_NUMERIC
    )
    .length(16, "Nomor SIM harus 16 karakter")
    .optional()
    .describe("Nomor SIM driver"),
  is_password_changed: z
    .boolean()
    .optional()
    .describe("Status perubahan password"),
  created_by_ulid: z.string().optional(),
  updated_by_ulid: z.string().optional(),
  created_at: z.string().optional(),
  updated_at: z.string().optional(),
});

// Partial schema for update driver data
export const driverSchema = driverDataSchema.omit({
  created_by_ulid: true,
  updated_by_ulid: true,
  created_at: true,
  updated_at: true,
  is_password_changed: true,
});

export const driverCsvSchema = driverSchema.partial().omit({
  ulid: true,
});
